
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PERMISSIONS } from '../../../constants';
import { checkPermisson } from '../../../selectors/common';
import { getTennisDownloadedLiveTemplateFile, getTennisLiveTemplateFile } from '../../../selectors/teams';
import PlayersTemplateFile from '..';
import { aDownloadTennisLiveTemplateFileRequest, aGetTennisLiveTemplateFileRequest, aSaveTennisLiveTemplateFileRequest } from '../../../reducers';

const mapToProps = (state) => ({
  downloadedLiveTemplateFile: getTennisDownloadedLiveTemplateFile(state),
  liveTemplateFile: getTennisLiveTemplateFile(state),
  checkPermisson: (payload) => checkPermisson(state, payload),
});

const actionsToProps = (dispatch) => ({
  getLiveTemplateFileRequest: (payload) => dispatch(aGetTennisLiveTemplateFileRequest(payload)),
  uploadLiveTemplateFileRequest: (payload) => dispatch(aSaveTennisLiveTemplateFileRequest(payload),
  ),
  downloadLiveTemplatesFile: (payload) => dispatch(aDownloadTennisLiveTemplateFileRequest(payload)),
});
class TennisLiveTemplateFile extends Component {
  constructor(props) {
    super(props);
    this.hasPermissionTo = {
      view: props.checkPermisson(PERMISSIONS.TENNIS_LIVE_TEMPLATE_FILES_VIEW),
      upload: props.checkPermisson(PERMISSIONS.TENNIS_LIVE_TEMPLATE_FILE_UPLOAD),
    };
  }

  componentDidMount() {
    this.props.getLiveTemplateFileRequest();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.downloadedLiveTemplateFile !== this.props.downloadedLiveTemplateFile) {
      window.location.assign(this.props.downloadedLiveTemplateFile.url);
    }
  }

  render() {
    return (
      <PlayersTemplateFile
        playersTemplateFile={this.props.liveTemplateFile}
        uploadPlayersTemplateFileRequest={this.props.uploadLiveTemplateFileRequest}
        hasPermissionToUpload={this.hasPermissionTo.upload}
        hasPermissionToView={this.hasPermissionTo.view}
        hasPermissionToDownload={this.hasPermissionTo.view}
        downloadPlayersTemplatesFile={this.props.downloadLiveTemplatesFile}
      />
    );
  }
}

export default connect(mapToProps, actionsToProps)(TennisLiveTemplateFile);
